export const sigortaSirketleriPage = () => `
  <section class="page-content">
    <div class="container">
      <h1 class="page-title">Anlaşmalı Sigorta Şirketleri</h1>
      <p class="page-subtitle">20+ sigorta şirketi ile çalışarak size en uygun teklifi sunuyoruz. Aşağıda anlaşmalı olduğumuz sigorta şirketlerini ve iletişim bilgilerini bulabilirsiniz.</p>

      <div class="sirket-grid">
        <div class="sirket-card">
          <h3>Anadolu Sigorta</h3>
          <p class="sirket-tel"><a href="tel:08507240850">0850 724 08 50</a></p>
        </div>
        <div class="sirket-card">
          <h3>Allianz Sigorta</h3>
          <p class="sirket-tel"><a href="tel:08503999999">0850 399 99 99</a></p>
        </div>
        <div class="sirket-card">
          <h3>Axa Sigorta</h3>
          <p class="sirket-tel"><a href="tel:08502509999">0850 250 99 99</a></p>
        </div>
        <div class="sirket-card">
          <h3>Mapfre Sigorta</h3>
          <p class="sirket-tel"><a href="tel:08507550505">0850 755 05 05</a></p>
        </div>
        <div class="sirket-card">
          <h3>Sompo Sigorta</h3>
          <p class="sirket-tel"><a href="tel:08502508181">0850 250 81 81</a></p>
        </div>
        <div class="sirket-card">
          <h3>HDI Sigorta</h3>
          <p class="sirket-tel"><a href="tel:08502090809">0850 209 08 09</a></p>
        </div>
        <div class="sirket-card">
          <h3>Zurich Sigorta</h3>
          <p class="sirket-tel"><a href="tel:08502507500">0850 250 75 00</a></p>
        </div>
        <div class="sirket-card">
          <h3>Generali Sigorta</h3>
          <p class="sirket-tel"><a href="tel:08505555555">0850 555 55 55</a></p>
        </div>
        <div class="sirket-card">
          <h3>Groupama Sigorta</h3>
          <p class="sirket-tel"><a href="tel:08502505050">0850 250 50 50</a></p>
        </div>
        <div class="sirket-card">
          <h3>Ray Sigorta</h3>
          <p class="sirket-tel"><a href="tel:08507429797">0850 742 97 97</a></p>
        </div>
        <div class="sirket-card">
          <h3>Doğa Sigorta</h3>
          <p class="sirket-tel"><a href="tel:08508115151">0850 811 51 51</a></p>
        </div>
        <div class="sirket-card">
          <h3>Quick Sigorta</h3>
          <p class="sirket-tel"><a href="tel:08507551414">0850 755 14 14</a></p>
        </div>
        <div class="sirket-card">
          <h3>Türk Nippon Sigorta</h3>
          <p class="sirket-tel"><a href="tel:08508888888">0850 888 88 88</a></p>
        </div>
        <div class="sirket-card">
          <h3>Koru Sigorta</h3>
          <p class="sirket-tel"><a href="tel:08502027070">0850 202 70 70</a></p>
        </div>
        <div class="sirket-card">
          <h3>Neova Sigorta</h3>
          <p class="sirket-tel"><a href="tel:08507245555">0850 724 55 55</a></p>
        </div>
        <div class="sirket-card">
          <h3>Bereket Sigorta</h3>
          <p class="sirket-tel"><a href="tel:08507242728">0850 724 27 28</a></p>
        </div>
        <div class="sirket-card">
          <h3>Ziraat Sigorta</h3>
          <p class="sirket-tel"><a href="tel:08502022020">0850 202 20 20</a></p>
        </div>
        <div class="sirket-card">
          <h3>Halk Sigorta</h3>
          <p class="sirket-tel"><a href="tel:08502029090">0850 202 90 90</a></p>
        </div>
        <div class="sirket-card">
          <h3>Türkiye Sigorta</h3>
          <p class="sirket-tel"><a href="tel:08502022020">0850 202 20 20</a></p>
        </div>
        <div class="sirket-card">
          <h3>Gulf Sigorta</h3>
          <p class="sirket-tel"><a href="tel:08502227070">0850 222 70 70</a></p>
        </div>
      </div>

      <div class="cta-section" style="text-align: center; margin-top: 40px;">
        <p>Hangi sigorta şirketinin size en uygun olduğunu bilmiyor musunuz?</p>
        <a href="/teklif-al" class="btn-primary" style="margin-top: 15px; display: inline-block;">Ücretsiz Teklif Alın</a>
      </div>
    </div>
  </section>
`;
